"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MessageTypes = void 0;
const MessageTypes = {
  events: {
    data: "post/term_js/events/data",
    resize: "post/term_js/events/resize",
    check: "post/term_js/events/check",
    data_push: "push/term_js/events/data",
    init_code_start_push: "push/term_js/events/init_code_start",
    init_code_done_push: "push/term_js/events/init_code_done"
  }
};
exports.MessageTypes = MessageTypes;
var _default = MessageTypes;
exports.default = _default;